import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotLayers = ({
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Spot=on,_Size=40_svg__a)">
            <path
                fill={spotColor}
                fillRule="evenodd"
                d="M21.5 8c3.35.756 9.372.966 13.25 4.766 3.878 3.811 6.665 10.498 4.485 14.332-2.192 3.823-9.43 3.368-15.735 4.902-6.317 1.545-11.769 3.665-15.58 1.95C4.123 32.237 2.065 28.113.93 23.343c-1.146-4.77-1.27-8.762-.157-12.1 1.1-3.337 3.462-6.01 6.148-6.89 2.698-.868 4.685-.12 7.08.647 1.953.834 4.14 2.233 7.5 3Z"
                clipRule="evenodd"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="m3.332 28.333 16.667 8.333 16.666-8.333M3.332 20l16.667 8.334L36.665 20M20 3.333 3.332 11.666 19.999 20l16.666-8.334L20 3.333Z"
            />
        </g>
        <defs>
            <clipPath id="Spot=on,_Size=40_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotLayers.displayName = "SpotLayers";
